module.exports = __webpack_public_path__ + "static/media/selfie_approved.8ef32591.svg";